export default "__VITE_ASSET__0a4b0117__"